import TopContent, { TopContentProps } from './TopContent';

export type { TopContentProps };
export default TopContent;
